<template>
  <div id="dashboard" class="main-container">
    <section class="has-margin-top-3">
      <h3 class="title zis-spaced">Suport d'Arrel</h3>

      <p class="desc has-margin-bottom-3" style="white-space: pre-line;">
        En temps de Covid-19 són moltes les iniciatives solidàries que sorgeixen al nostre entorn; projectes que han transformat part de la seva activitat econòmica convencional a una activitat que, sense esperar res a canvi, reverteix a tota la comunitat. Aquestes iniciatives inverteixen de manera solidària material, temps, diners i energia pel bé comú.

        Suport d'arrel proposa aportar recursos a totes aquestes iniciatives per tal que puguin seguir duent a terme les activitats.

        SUPORT ja que confinades des de casa, tenim l'oportunitat de descobrir i aportar a aquestes iniciatives allò que necessiten, tot fent un retorn des de la comunitat.

        D'ARREL perquè les nostres aportacions fan possible que les iniciatives siguin més viables i sostenibles.

        En temps d'emergència les arrels d'una economia solidària continuen agafant forma a la nostra comarca, és cosa de totes que puguin seguir expendint-se i arrelant fort. Cuidem-nos, entre totes i des de tots els espais imaginables.
      </p>
      <hr />
      <p class="desc has-margin-bottom-3" style="white-space: pre-line;">
        Suport d'arrel és una campanya impulsada per la <a class="has-text-danger" target="_blank" href="http://nuriasocial.org/xesgarrotxa/">XES Garrotxa</a> per fer visibles i facilitar el suport a les iniciatives que ofereixen els seus serveis i productes de manera solidària durant la situació d'emergència provocada pel Covid-19.

        La campanya es basa en una plataforma web, facilitada per <a target="_blank" class="has-text-danger" href="https://webcoop.cat">Webcoop</a>, que recull les iniciatives solidàries de la comarca i on es proposa a la població que hi pugui donar suport, ja sigui fent aportacions econòmiques, de cures, de material, infraestructura o el que es pugui arribar a necessitar com a recurs per seguir fent possible l'activitat solidària de les diverses iniciatives.
      </p>
      <hr />
      <p class="desc has-margin-bottom-3" style="white-space: pre-line;">
        Cada iniciativa que vulgui formar part del directori haurà d'introduïr directament les seves dades i descripció de l'activitat que està duent a terme al web. Serà molt important que descrigui quin és el recurs que necessita (diners, tipus de material, cures, infraestructura,...).

        No hi haurà transaccions econòmiques ni xats interns a aquesta plataforma.

        Cada persona/entitat que vulgui fer una aportació es posarà en contacte amb la iniciativa a través dels contactes publicats al web (telèfon/mail/enllaç Paypal/...). 
      </p>
      <hr />
      <h3 class="title">Contacte</h3>
      <p class="desc has-margin-bottom-3" style="white-space: pre-line;">
        garrotxa@xes.cat

        hola@webcoop.cat
      </p>
      

    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");
import MyBoxes from "@/components/MyBoxes";
import AllBoxes from "@/components/AllBoxes";
import MyDownloads from "@/components/MyDownloads";

export default {
  data() {
    return {};
  },
  components: {
    MyBoxes,
    AllBoxes,
    MyDownloads
  },
  computed: {
    ...mapState([])
  },
  mounted() {},
  methods: {}
};
</script>
<style scoped>
.section {
  padding: 3rem 0;
}
#dashboard {
  margin-top: -30px;
}
.desc {
  margin-bottom: 1rem;
  color: #727475;
}
.mt-2 {
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/HowWorks.vue